<div *ngIf="config$ | async as config">
  <!-- DESKTOP -->
  <div class="plans-desktop-wrapper d-none d-md-block">
    <div class="row justify-content-center plan-selection-btn-desktop-wrapper">
      <div class="cards-section row justify-content-center">
        <div
          *ngFor="let plan of config.plans; trackBy: trackByConfigPlan"
          floAnalytics
          class="col-lg-3 col-md-4 {{
            plan?.period + '-' + plan?.cost_per_month?.amount?.toString()
          }}"
          [ngClass]="{
            'is-single-plan': config.hasOneShownPlan
          }"
          [elementName]="
            plan?.yearly ? 'Yearly Subscription' : 'Monthly Subscription'
          "
          tagName="Radio Button"
        >
          <flo-plan-selection-card
            [hasOneShownPlan]="config.hasOneShownPlan"
            [selectedPlan]="config.selectedPlan"
            [plan]="plan"
            [valueProps]="config.valueProps"
            [savingsText]="config.savingsProps"
          >
          </flo-plan-selection-card>
        </div>
      </div>
    </div>
  </div>

  <!-- MOBILE -->
  <div class="plans-mobile-wrapper d-md-none">
    <div class="plan-tiles-wrapper">
      <div
        *ngFor="let plan of config.plans; trackBy: trackByConfigPlan"
        floAnalytics
        class="mobile-plan-tile {{
          plan?.period + '-' + plan?.cost_per_month?.amount?.toString()
        }}"
        [ngClass]="{
          'is-single-plan': config.hasOneShownPlan
        }"
        [elementName]="
          plan?.yearly ? 'Yearly Subscription' : 'Monthly Subscription'
        "
        tagName="Radio Button"
      >
        <flo-plan-selection-card
          [hasOneShownPlan]="config.hasOneShownPlan"
          [selectedPlan]="config.selectedPlan"
          [plan]="plan"
          [valueProps]="config.valueProps"
          [savingsText]="config.savingsProps"
        >
        </flo-plan-selection-card>
      </div>
    </div>

  </div>
</div>
